import React, { useState, useRef } from "react";
import styles from "./uploadFile.module.scss";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

const UploadFile = (props) => {
  const { onUpload = () => {} } = props;
  const [file, setFile] = useState(null);

  const fileInput = useRef(null);

  const handleSelectFileUpload = (e) => {
    setFile(e.target.files.length > 0 ? e.target.files[0] : null);
  };

  const handleOkClick = (e) => {
    const data = new FormData();
    data.append("files", file);
    onUpload(data);
  };

  return (
    <div>
      <input type="file" ref={fileInput} onChange={handleSelectFileUpload} style={{ display: "none" }} />
      <div className={styles.uploadButton}>
        <div
          onClick={() => {
            fileInput.current.click();
          }}
        >
          <DriveFolderUploadIcon fontSize="large" />
        </div>

        <div>
          <span>{file !== null ? file.name : null}</span>
        </div>

        {file !== null ? (
          <div lassName={styles.okButton}>
            <ButtonPrimary title="OK" minWidth={35} handleClick={handleOkClick} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(UploadFile);


